import React from "react";
import Swal from "sweetalert2";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import { MdDelete } from "react-icons/md";
function DeleteEnquiry(props) {
  const handleDelete = async (enquiryID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const obj = {
          query: `[dbo].[CRM_Proc_Delete_Enquiry_Submit] @EnquiryID='{0}'`,
          queryArr: [`${enquiryID}`],
        };
        try {
          const resp = await Hexapi(obj);
          const result = resp[""]?.[0];
          const msg = result?.msg || "No response message from server.";
          const cmd = result?.command;

          if (cmd === 1) {
            Swal.fire({
              icon: "success",
              title: "Success!",
              text: msg,
              timer: 1500,
              showConfirmButton: false,
            });
            setTimeout(() => {
            }, 500);
          } else if (cmd === 0) {
            Swal.fire({
              icon: "warning",
              title: "Action Failed",
              text: msg,
            });
          }
        } catch (err) {
          console.error("Delete Error:", err);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to delete the record.",
          });
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "Cancelled",
          text: "The record was not deleted.",
        });
      }
    });
  };
  return (
    <>
      <MdDelete
        style={{ cursor: "pointer", fontSize: "25px" }}
        title="Delete"
        onClick={() => {
          handleDelete(props.enquiryID);
        }}
      />
    </>
  );
}

export default DeleteEnquiry;
